import React from 'react'

import { ChargePoint } from '../../redux/api/web-api'

import { EapiCallbacksPanel } from './eapi-callbacks-panel'
import { OcppProxyPanel } from './ocpp-proxy-panel'

export type ChargepointIntegrationsWidgetProps = {
    chargePoint: ChargePoint
}

export function ChargepointIntegrationsWidget({ chargePoint }: ChargepointIntegrationsWidgetProps): React.ReactElement {
    return (
        <div className="flex flex-row w-full gap-4">
            <EapiCallbacksPanel chargePoint={chargePoint} />
            <OcppProxyPanel chargePoint={chargePoint} />
        </div>
    )
}
